define('app/views/defaultAnalytics/cart',[], function () {
  return {
    showCartContents: function (cartData) {
      var gtmCartReported = app.datal('gtmCart') || {};
      cartData && _.each(cartData.WebFolioItem, function(booking,i){
          if (booking.Category=='Hotel') {
              var uniqueID = booking.Category+'-'+booking.FolioId
              if (!gtmCartReported[uniqueID]) {
                  var startDate = Date.parse( booking.StartDate.substr(0,10) ),
                      finishDate = Date.parse( booking.FinishDate.substr(0,10) ),
                      duration = Math.round( (finishDate - startDate) / 1000 / 24 / 60 /60 )
                  gtmCartReported[uniqueID] = {
                      'name': booking.RateType,
                      'id': "Room-" + booking.RateType + "-" + booking.RoomType,
                      'price': booking.RoomRate,
                      'brand': booking.Location,
                      'category': booking.RoomType,
                      'quantity': duration
                  }

                  if(app.customization.dataLayerEvents){
                    dataLayer.push({
                      'event': 'addToCart',
                      'ecommerce': {
                        'add': [ gtmCartReported[uniqueID] ]
                      }
                    });
                  }

                  gtag('event', 'add_to_cart', {
                    item_name: booking.Details,
                    item_id: "Room-" + booking.RateType + "-" + booking.RoomType,
                    sku: "Room-" + booking.RateDetails+ '-' +booking.Details,
                    affiliation: app.localization.siteName,
                    price: booking.RoomRate && +booking.RoomRate,
                    quantity: duration,
                    currency: app.customization.currencyCode,
                    item_category: booking.RoomType,
                    item_category2: booking.RateType,
                    tax: booking.FolioSurcharges && +booking.FolioSurcharges,
                  });

                  app.datal('gtmCart', gtmCartReported)
              }

              if(booking.specialServices && booking.specialServices.length){
                _.each(booking.specialServices, function(service){
                    var uniqueSpID = booking.Category+'-'+booking.FolioId +'-'+ service.PMSSpecialService.PMSItemId + '-' + service.PMSFolioSpecialServiceId
                    if(!gtmCartReported[uniqueSpID]){
                        gtmCartReported[uniqueSpID] = {
                        'name': service.PMSSpecialService.PMSSpecialServiceName,
                        'id': service.PMSSpecialService.PMSItemId,
                        'price': +service.PMSSpecialService.Price,
                        'brand': booking.Location,
                        'category': service.PMSSpecialService.PMSSpecialServiceName,
                        'quantity': service.Qty
                        }
                        if(app.customization.dataLayerEvents){
                            dataLayer.push({
                                'event': 'addToCart',
                                'ecommerce': {
                                    'add': [ gtmCartReported[uniqueSpID] ]
                                }
                            });
                        }
                      gtag('event', 'add_to_cart', {
                        'item_id': service.PMSSpecialService.PMSItemId,
                        'sku': service.PMSSpecialService.PMSSpecialServiceName,
                        'item_name': service.PMSSpecialService.PMSSpecialServiceName,
                        'affiliation': app.localization.siteName,
                        'item_category': service.PMSSpecialService.PMSSpecialServiceName,
                        'price': +service.PMSSpecialService.Price,
                        'quantity': service.Qty
                      });
                      app.datal('gtmCart',gtmCartReported)
                    }
                })
              }
          } else {
              var uniqueID = booking.Category+'-'+ (booking.FolioItemId || booking.BookingId || booking.FolioId);
              var isGolf = booking.Category=='Golf';

              if (!gtmCartReported[uniqueID]) {
                  var id = isGolf ? (booking.Category + "-" + booking.CourseId + '-' + booking.ItemId + '-' + booking.Details):(booking.Category + "-" + (booking.ItemId ? booking.ItemId + '-' : '') + booking.Details)
                  var category = isGolf ? booking.CourseId : booking.Category;
                  var price = isGolf ? +booking.EachAmount : +booking.Amount;
                  var qty = isGolf ? +booking.Players : 1;

                  gtmCartReported[uniqueID] = {
                      'name': booking.Details,
                      'id': id,
                      'price': price,
                      'brand': booking.Location,
                      'category': category,
                      'quantity': qty
                  }

                  if(app.customization.dataLayerEvents){
                    dataLayer.push({
                      'event': 'addToCart',
                      'ecommerce': {
                        'add': [ gtmCartReported[uniqueID] ]
                      }
                    });
                  }

                  gtag('event', 'add_to_cart', {
                    item_name: booking.Details,
                    item_id: id,
                    sku: id,
                    affiliation:app.localization.siteName,
                    item_category: category,
                    price: price,
                    quantity: qty,
                    currency: app.customization.currencyCode,
                    tax: booking.FolioSurcharges && +booking.FolioSurcharges,
                  });
                  
                  app.datal('gtmCart', gtmCartReported)
              }
          }
      })
    },
    removeItem: function (folioBookings, type, folioId, folioItemId, waitListId) {
      if(folioBookings.WebFolioItem && folioBookings.WebFolioItem.length){
          var golfGrouped = {},
          newItems = [];
          _.each(folioBookings.WebFolioItem, function(v,k,l){
              if (v.Category=="Golf") {
                  if (golfGrouped[v.FolioId]) {
                      golfGrouped[v.FolioId].Amount += +v.Amount;
                      // golfGrouped[v.FolioId].FolioPayments += +v.FolioPayments;
                      golfGrouped[v.FolioId].Players += 1;
                  } else {
                      golfGrouped[v.FolioId] = v;
                      golfGrouped[v.FolioId].Players = 1;
                      golfGrouped[v.FolioId].EachAmount = +v.Amount;
                      golfGrouped[v.FolioId].Amount = +v.Amount;
                      // golfGrouped[v.FolioId].FolioPayments = +v.FolioPayments;

                  }

                  delete l[k];
              } else if (v.specialServicesAvailable) {
                  var newSpecialServicesAvailable = [];
                  _.each(v.specialServicesAvailable, function(vv,kk,ll){
                      if (vv.IsCharged=='1') {
                          var startDate = Date.parseExact(v.StartDate, "yyyy-MM-ddHHmmss"),
                              endDate = Date.parseExact(v.FinishDate, "yyyy-MM-ddHHmmss");
                          vv.dateList = [];
                          for (var theDate = startDate.clone(); theDate < endDate; theDate.add(1).day()) {
                              vv.dateList.push({
                                  human:theDate.toString(app.localization.CultureInfo.formatPatterns.longDate),
                                  machine:theDate.toString("yyyy-MM-dd")
                              });
                          }
                      }
                      if (v.pmsVenue && v.pmsVenue.GuestNoteServiceName == vv.PMSSpecialServiceName) {
                          v.guestNoteSpecialService = vv;
                      } else {
                          newSpecialServicesAvailable.push(vv);
                      }
                  });
                  v.specialServicesAvailable = newSpecialServicesAvailable;
                  if (_.any(app.data.pmsDayBookings,function(x){return x==v.FolioId})) {
                      v.isDayBooking = true;
                  }
                  v.PreDepositAmount = v.FolioTotal;
                  newItems.push(v);
              } else {
                  if (v.Category=="Hotel" && _.any(app.data.pmsDayBookings,function(x){return x==v.FolioId})) {
                      v.isDayBooking = true;
                  }
                  v.PreDepositAmount = v.FolioTotal;
                  if (v.Category=="Spa"||v.Category=="Ski") {
                      v.PreDepositAmount = v.Amount;
                      v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments

                  }
                  if (v.Category=="Ski") {
                      var guestRequest = app.data.skiGuestNotes && app.data.skiGuestNotes[v.FolioItemId]
                      v.guestRequest = guestRequest;
                      if(v.FinishDate){
                          v.FinishDate = Date.parseExact(v.FinishDate.substr(0,10), "yyyy-MM-dd").add(-1).days().toString('yyyy-MM-dd') + v.FinishDate.substr(10)
                      }
                  }
                  if (v.Category=="Spa") {  
                      var guestRequest = app.data.classGuestNotes && app.data.classGuestNotes[v.FolioItemId]
                      v.guestRequest = guestRequest;
                  }
                  if (v.Category=="Retail") {
                      v.Amount = v.PreDepositAmount;
                  }
                  newItems.push(v);
              }
              if(v.Category == "PMSPayment"){
                  _.each(app.data.pmsBookings,function(pms){
                      if(pms.PMSFolioId == v.FolioId){
                          v.StartDate = pms.ArrivalDate
                          v.FinishDate = pms.DepartureDate
                          v.Location = pms.Venue
                      }
                  })

              }
              if(v.Category == "SPAPayment"){
                  _.each(app.data.spaBookings,function(spa){
                      if(spa.SpaFolioId == v.FolioId){
                          v.Location = spa.SpaFolioItem.LocationName
                      }
                  })

              }
          });
          _.each(golfGrouped, function(v,k,l){
              v.PreDepositAmount = v.Amount;
              v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments
              newItems.push(v);
          });
          folioBookings.WebFolioItem = newItems;
          var folioBooking = _.find(folioBookings.WebFolioItem, function (booking) {
            return booking.FolioId == folioId || booking.BookingId == waitListId || booking.FolioItemId == folioItemId;
          });
          if(folioBooking){
            var itemID, category, price, qty, tax, categoryTwo;
            if(folioBooking.Category == 'Hotel'){
              var startDate = Date.parse( folioBooking.StartDate.substr(0,10) ),
                  finishDate = Date.parse( folioBooking.FinishDate.substr(0,10) ),
                  duration = Math.round( (finishDate - startDate) / 1000 / 24 / 60 /60 )
                itemID = "Room-" + folioBooking.RateType + "-" + folioBooking.RoomType;
                category = folioBooking.RoomType;
                categoryTwo = folioBooking.RateType;
                price = +folioBooking.RoomRate;
                qty = duration;
                tax = folioBooking.FolioSurcharges && +folioBooking.FolioSurcharges;
            } else if (folioBooking.Category == 'Golf'){
                itemID = folioBooking.Category + "-" + folioBooking.CourseId + '-' + folioBooking.ItemId + '-' + folioBooking.Details
                category = folioBooking.CourseId;
                categoryTwo = folioBooking.Category;
                price = +folioBooking.EachAmount;
                qty = +folioBooking.Players;
                tax = folioBooking.FolioSurcharges && +folioBooking.FolioSurcharges;
            } else {
                itemID = folioBooking.Category + "-" + (folioBooking.ItemId ? folioBooking.ItemId + '-' : '') + folioBooking.Details
                category = folioBooking.Category == 'Spa' ? folioBooking.ItemCategory : folioBooking.Category;
                categoryTwo = folioBooking.Category == 'Spa' ? folioBooking.ItemSubcat : '';
                price = (folioBooking.Amount ? +folioBooking.Amount : +folioBooking.PreDepositAmount) || 0;
                qty = 1;
                tax = folioBooking.FolioSurcharges && +folioBooking.FolioSurcharges;
            }
            gtag("event", "remove_from_cart", {
              currency: app.customization.currencyCode,
              value: price,
              items: [
                {
                  item_id: itemID,
                  item_name: folioBooking.Details,
                  affiliation: app.localization.siteName,
                  item_category: category,
                  item_category2: categoryTwo,
                  price: price,
                  quantity: qty
                }
              ]
            });
          }

      }
    }
  };
});

